import type { IconData } from '@stacksjs/iconify-core'

export const disableProtectionFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24.84 2.391c-9.174 0-14.189.652-16.86 1.243c-2.373.525-3.728 2.516-3.976 4.657a103 103 0 0 0-.664 11.6c0 9.545 5.04 18.533 13.606 22.942c2.684 1.381 5.588 2.558 7.894 2.558s5.21-1.177 7.894-2.558C41.3 38.424 46.34 29.436 46.34 19.89c0-4.905-.37-9.067-.664-11.6c-.248-2.14-1.604-4.132-3.976-4.657c-2.672-.59-7.686-1.243-16.86-1.243Z\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M1.232 1.232a2.5 2.5 0 0 1 3.536 0l40 40a2.5 2.5 0 0 1-3.536 3.536l-40-40a2.5 2.5 0 0 1 0-3.536\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableProtectionFlat
